import { Components, Theme } from '@mui/material/styles';

export const inputTheme: Components<Theme>['MuiTextField'] = {
  // styleOverrides: {},
  // variants: [],
};
